import { DrawingLayer } from 'business/models/DrawingLayer';
import { RandomLayerDTO } from 'business/models/Models';

export default class RandomLayerIngredientGroup {
  public static GetUsedGroupIDsByRandomLayerID(lyr: DrawingLayer) {
    const groupIDs: number[] = [];
    const detail: RandomLayerDTO = lyr.layerDetail as RandomLayerDTO;
    for (const groupRow of detail.randomLayerIngredientGroup) {
      if (
        groupRow.randomLayerGenerationList.findIndex(
          (gl) => gl.randomLayerIngredientGroupId === groupRow.id,
        ) >= 0
      ) {
        groupIDs.push(groupRow.id);
      }
    }
    return groupIDs;
  }
}
